import TemplateView from "../../../TemplateView";

export default class DeleteConfirmationCell extends TemplateView {
    constructor({
        deleteMessageKey,
        onConfirm = () => {},
        onCancel = () => {}
    }) {
        super()
        this.deleteMessageKey = deleteMessageKey

        this.params = {
            onConfirm,
            onCancel
        }
    }

    templateHtml() {
        return "<div class='deleteConfirmationRow'>" +
               "    <div class='messageWrapper'><span class='message'><%=message%></span></div>" +
               "    <div class='confirmBtn'><button><%=confirm%></button></div>" +
               "    <div class='cancelBtn'><%=cancel%></div>" +
               "</div>"
    }

    messageKeys() {
        return {
            message: this.deleteMessageKey,
            confirm: "common.delete_confirm",
            cancel: "common.cancel"
        }
    }

    afterRender() {

        this.find('.confirmBtn').click(e => {
            e.stopPropagation()
            this.params.onConfirm()
        });
        this.find('.cancelBtn').click(e => {
            e.stopPropagation()
            this.params.onCancel()
        });
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/user/accountSettings/DeleteConfirmationCell.js